import { render } from "./CustomizeColumnModal.vue?vue&type=template&id=c0739398&scoped=true"
import script from "./CustomizeColumnModal.vue?vue&type=script&lang=js"
export * from "./CustomizeColumnModal.vue?vue&type=script&lang=js"

import "./CustomizeColumnModal.vue?vue&type=style&index=0&id=c0739398&lang=less&scoped=true"
import "./CustomizeColumnModal.vue?vue&type=style&index=1&id=c0739398&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0739398"]])

export default __exports__